import { schema } from 'normalizr'

import * as schemas from './individual.schema'

export const patientsSchema = new schema.Entity('patientContainer', {
    patients: [schemas.patients],
    admissions: [schemas.admissions],
    diagnosis: [schemas.diagnosis],
    insured: [schemas.insured],
    caseMgrs: [schemas.caseMgrs],
    auths: [schemas.auths],
    pocs: [schemas.pocs],
    fotoSurveys: [schemas.fotoSurveys],
    cdv: [schemas.cdv],
    diary: [schemas.diary],
    scans: [schemas.scans],
    apptHist: [schemas.apptHist],
    peerReviews: [schemas.peerReviews],
    peerReviewMsgs: [schemas.peerReviewMsgs],
    trtCodes: [schemas.trtCodes]
});
